import styled from 'styled-components';

export const StyledHeader = styled.header<{ stickyOnMobile?: boolean }>`
    position: relative;
    background: var(--bg--base);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        ${({ stickyOnMobile }) =>
            stickyOnMobile
                ? `
            position: sticky;
            top: 0;
            z-index: 10;
        `
                : ''}
    }
`;

export const StyledHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 8px 24px;
`;

export const StyledMenuContainer = styled.div`
    @media (max-width: 768px) {
        position: absolute;
        z-index: 1;
        left: 5%;
        top: 50%;
        transform: translateY(-50%);
    }
`;

export const StyledDesktopMenuContainer = styled.div`
    @media (max-width: 768px) {
        display: none;
    }
`;

export const StyledMobileMenuContainer = styled.div`
    display: none;

    @media (max-width: 768px) {
        display: block;
    }
`;

export const StyledKSCLogo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
        margin: 0 auto;
    }
`;
